import {chapter1} from "./quests/chapter_1/chapter_1";
import {chapter2} from "./quests/chapter_2/chapter_2";
import {chapter3} from "./quests/chapter_3/chapter_3";
import {chapter4} from "./quests/chapter_4/chapter_4";
import {chapter5} from "./quests/chapter_5/chapter_5";
import {chapter6} from "./quests/chapter_6/chapter_6";

export const quests = [
    chapter1,
    chapter2,
    chapter3,
    chapter4,
    chapter5,
    chapter6
];
